module.exports = __webpack_public_path__ + "static/david-bc84ea3839a695daed0e207acd8f8385.png";